import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-boleta',
  templateUrl: './boleta-electronica.component.html',
  styleUrls: ['./boleta-electronica.component.scss']
})
export class BoletaElectronicaComponent implements OnInit {
  textoImg = {img: "./assets/img/bannerInferior/slider-1-0.png"}

  slides = [
    {img: "./assets/img/bannerInferior/slider-1.png"},
    {img: "./assets/img/bannerInferior/slider-1.png"},
  ];
  slideConfig = {
    "slidesToShow": 1,
    "slidesToScroll": 1,
    "arrows": false,
    "dots": false,
    "fade": true
  };

  constructor() { }

  ngOnInit() {
  }

  addSlide() {
    this.slides.push({img: "http://placehold.it/350x150/777777"})
  }

  removeSlide() {
    this.slides.length = this.slides.length - 1;
  }

  slickInit(e) {
  }

  breakpoint(e) {
  }

  afterChange(e) {
  }

  beforeChange(e) {
  }
}
